import { render } from "./Clock.vue?vue&type=template&id=8c553f60&scoped=true"
import script from "./Clock.vue?vue&type=script&lang=js"
export * from "./Clock.vue?vue&type=script&lang=js"

import "./Clock.vue?vue&type=style&index=0&id=8c553f60&lang=scss&scoped=true"

import exportComponent from "/Users/ganl/Code/vue-digital-transform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c553f60"]])

export default __exports__